import React from 'react';

import FormSupervisor  from 'components/Tvendo/Sale/QuotaBPartner/GoogleForm/Supervisor/List.js';

export default function () {
  return <FormSupervisor  />;
}